<template>
	<v-card 
		class="mx-auto"
		flat
		:max-width="maxWidth"
		:loading="loading"
	>
		<v-app-bar flat color="transparent">
			<v-btn v-if="step > 0" icon @click="$emit('previous')">
				<v-icon>mdi-arrow-left</v-icon>
			</v-btn>
			<v-toolbar-title class="text-h6">
				{{ title }}
			</v-toolbar-title>
		</v-app-bar>
		<!-- <v-card-title>{{ title }}</v-card-title> -->
		<!-- <v-card-subtitle>{{ subtitle }}</v-card-subtitle > -->
		<!-- <v-card-subtitle v-if="subtitle && subtitle.length">{{ subtitle }}</v-card-subtitle > -->
		<v-card-text>
			<!-- Отримання інформації з єдиного державного реєстру транспортних засобів про реєстрацію транспортного засобу <b>{{ item.number }}</b>, <b>{{ item.vin }}</b> -->
			Отримання інформації з єдиного державного реєстру транспортних засобів про реєстрацію транспортного засобу. Завантажити інформацію можна за державним номером або за vin-кодом.
			<v-row>
				<v-col cols="12" md=6>
					<v-btn text
						color="primary"
						depressed
						block
						@click="onRequest('number')"
					>
						{{ item.number }}
					</v-btn>
				</v-col>
				<v-col cols="12" md=6>
					<v-btn text
						color="primary"
						depressed
						block
						@click="onRequest('vin')"
					>
						{{ item.vin }}
					</v-btn>
				</v-col>
			</v-row>
		</v-card-text>
		
		<!-- <v-list subheader three-line> -->
		<!-- <v-list subheader>
			<v-subheader>Дані з єдиного державного реєстру транспортних засобів</v-subheader>

			<v-list-item v-for="item in registrations" :key="item.code">
				<v-list-item-content>
					<v-list-item-title>{{ item.name }}</v-list-item-title>
					<v-list-item-subtitle>{{ item.value }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-list> -->

		<v-card-text>
			<v-simple-table dense>
				<template v-slot:default>
					<!-- <thead>
						<tr>
							<th class="text-left">Назва</th>
							<th class="text-left">Значення</th>
						</tr>
					</thead> -->
					<tbody>
						<tr v-for="item in registrations" :key="item.code">
							<td>{{ item.name }}</td>
							<td>{{ item.value }}</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</v-card-text>

		<!-- <v-card-actions v-if="registrations.length > 0"> -->
		<v-card-actions>
			<v-spacer></v-spacer>
				<v-btn
					color="indigo"
					dark
					rounded
					block
					@click="$emit('next')"
				>
					Далі
				</v-btn>
			<v-spacer></v-spacer>
		</v-card-actions>
	</v-card>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'

export default {
	mixins: [mixin],

	props: {
		code:				{ type: String },
		title:				{ type: String, default: "Державна реєстрація" },
	},

	computed: {
		registrations() {
			return this.item?.registry?.registrations ? this.item.registry.registrations: [];
		},
	},

	methods: {

		onRequest(variant){
			var that = this
			let params = null

			switch(variant) {
				case 'number'	: params = this.item?.number ? { number: this.item.number } : null; break;
				case 'vin'		: params = this.item?.vin ? { vin: this.item.vin } : null; break;
			}

			if (params) {
				//console.log(this.$options.name, 'onRequest', params)
				
				this.loading = true
				//axios.post('/vehicle/estimate/identify', params).then(response => {
				//axios.get('/tinex/TzInfo', params).then(response => {
				axios.get('/tinex/registry', { params: params }).then(response => {
					//console.log(that.$options.name, 'onOK','response', response)
					//console.log(that.$options.name, 'onRequest','response.data', response.data)
					this.$set(this.item, 'registry', response.data)
					//that.setItem(response.data)

					//console.log(that.$options.name, 'onRequest','item', that.item)
				}, error => {
					console.log('error', error)

					//that.snackbar.visible 	= true;
					//that.snackbar.text 		= error.response.data.message;
					//that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onNext(){
			/* if (this.$refs.form.validate()) {

			} */
		},

		keyupNumber(){
			//this.item.number = this.defaultNumber
			this.$set(this.item,'number', this.defaultNumber)
		},

		keyupVin(){
			//this.item.vin = this.defaultVin
			this.$set(this.item,'vin', this.defaultVin)
		},
	},
}
</script>
